import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

function OrderStatusEditPage() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [token] = useState(localStorage.getItem('adminToken'));

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        if (!token) throw new Error('Unauthorized: Admin token missing');
        const res = await fetch(`${API_BASE_URL}/api/admin/orders/${orderId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.message || 'Failed to load order');
        }

        const data = await res.json();
        setStatus(data.status);
        setLoading(false);
      } catch (err) {
        setMessage(err.message);
        setLoading(false);
      }
    };

    fetchOrder();
  }, [orderId, token, API_BASE_URL]);

  const updateStatus = async () => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/orders/${orderId}/status`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ status }),
      });

      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || 'Update failed');
      }

      setMessage('Status updated successfully');
      setTimeout(() => navigate('/orders'), 1000);
    } catch (err) {
      setMessage(err.message);
    }
  };

  return (
    <div className="container my-5 bg-white p-4 my-5 rounded shadow-sm" style={{ maxWidth: '480px' }}>
      <h2 className="mb-4 text-center">Edit Order Status</h2>

      {loading ? (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status" aria-hidden="true"></div>
          <div className="mt-2">Loading...</div>
        </div>
      ) : (
        <>
          {message && (
            <div className="alert alert-info rounded-3 py-2 px-3">
              {message}
            </div>
          )}

          <div className="mb-4 d-flex justify-content-center">
            <select
              className="form-select form-select-sm w-50"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Processing">Processing</option>
              <option value="confirmed">Confirmed</option>
              <option value="shipped">Shipped</option>
              <option value="delivered">Delivered</option>
              <option value="cancelled">Cancelled</option>
            </select>
          </div>

          <div className="d-flex justify-content-center gap-3">
            <button
              className="btn btn-success px-4 py-2 rounded-pill fw-semibold"
              onClick={updateStatus}
            >
              Update
            </button>
            <button
              className="btn btn-outline-secondary px-4 py-2 rounded-pill"
              onClick={() => navigate('/orders')}
            >
              Cancel
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default OrderStatusEditPage;
